import React, { ReactNode } from 'react';

// Props for the RenderIf component
type RenderIfProps = {
  condition: boolean;
  children: ReactNode;
};

// Props for the Else component
type ElseProps = {
  children: ReactNode;
};

// Create a compound component with an Else sub-component
const RenderIf = ({ condition, children }: RenderIfProps) => {
  // Find the Else component in children, if it exists
  const elseChild = React.Children.toArray(children).find(
    (child) => React.isValidElement(child) && child.type === RenderIf.Else
  );

  const ifChildren = React.Children.toArray(children).filter(
    (child) => !(React.isValidElement(child) && child.type === RenderIf.Else)
  );

  // Render based on condition
  if (condition) {
    return <>{ifChildren}</>;
  }

  return elseChild ? <>{elseChild}</> : null;
};

// Define the Else sub-component
const Else = ({ children }: ElseProps) => <>{children}</>;

Else.displayName = 'RenderIf.Else';
RenderIf.Else = Else;

// Set displayName for the main component
RenderIf.displayName = 'RenderIf';

// Export the component
export default RenderIf;
